import NotFound from "@/pages/not-found/Index";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HashRouter, Routes, Route, Navigate } from "react-router-dom";
import { ROUTE_PATHS } from "@/lib/index";
import { useAuth } from "@/hooks/useAuth";
import Home from "@/pages/Home";
import Cemetery from "@/pages/Cemetery";
import Reservation from "@/pages/Reservation";
import GraveCreator from "@/pages/GraveCreator";
import Idea from "@/pages/Idea";
import AuthPage from "@/pages/Auth";
import AccountPage from "@/pages/Account";
import VersionsPage from "@/pages/Versions";
import PrivacyPage from "@/pages/Privacy";
import TermsPage from "@/pages/Terms";
import AuthCallbackPage from "@/pages/AuthCallback";
import ThemePreviewPage from "@/pages/ThemePreview";
import AdminPage from "@/pages/Admin";

const queryClient = new QueryClient();

export const ALLOWED_EMAILS: string[] = ['arek@e-grob.pl', 'piotr@e-grob.pl'];

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-foreground">Ładowanie...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to={ROUTE_PATHS.LOGOWANIE} replace />;
  }

  return <>{children}</>;
}

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <HashRouter>
        <Routes>
          <Route path={ROUTE_PATHS.HOME} element={<Home />} />
          <Route path={ROUTE_PATHS.IDEA} element={<Idea />} />
          <Route path={ROUTE_PATHS.CMENTARZ} element={<Cemetery />} />
          <Route path={ROUTE_PATHS.REZERWACJA} element={<Reservation />} />
          <Route path={ROUTE_PATHS.KREATOR} element={<GraveCreator />} />
          <Route path={ROUTE_PATHS.LOGOWANIE} element={<AuthPage />} />
          <Route path={ROUTE_PATHS.REJESTRACJA} element={<AuthPage />} />
          <Route
            path={ROUTE_PATHS.KONTO}
            element={
              <ProtectedRoute>
                <AccountPage />
              </ProtectedRoute>
            }
          />
          <Route path={ROUTE_PATHS.WERSJE} element={<VersionsPage />} />
          <Route path={ROUTE_PATHS.POLITYKA} element={<PrivacyPage />} />
          <Route path={ROUTE_PATHS.REGULAMIN} element={<TermsPage />} />
          <Route path={ROUTE_PATHS.AUTH_CALLBACK} element={<AuthCallbackPage />} />
          <Route path="/motywy-podglad" element={<ThemePreviewPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </HashRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;